import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import RouteWrapper from "../AppContainer/RouteWrapper";

class SubscriptionRoute extends Component {
    constructor(props) {
        super(props);
    }

    checkUrlValidity = () => {
        if (this.props.urlsInfo[this.props.path]?.pageLevelCheck) {
            if (this.props.packageObj.features[this.props.urlsInfo[this.props.path].propertyToCheck].quota === 0) {
                toast.error(
                    `${
                        this.props.packageObj.features[this.props.urlsInfo[this.props.path].propertyToCheck].name
                    } are not available in your current subscrition package. Kindly upgrade to use it.`,
                );
                return false;
            }
        }
        return true;
    };

    render() {
        return this.checkUrlValidity() ? <RouteWrapper {...this.props} /> : <Redirect to={this.props.urlsInfo[this.props.path].redirectPathIfInvalid} />;
    }
}

const mapStateToProps = (state) => ({
    urlsInfo: state.globalReducer.urlsInfo,
    packageObj: state.globalReducer.packageObj,
});

export default connect(mapStateToProps)(SubscriptionRoute);
